import React from 'react';
import PropTypes from 'prop-types';
import { Form, Button } from 'react-bootstrap';
const _ = {
    filter: require('lodash/filter'),
    find: require('lodash/find'),
    map: require('lodash/map'),
    assign: require('lodash/assign'),
    get: require('lodash/get'),
}
const uuid = require('uuid');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const StringUtil = require('../../../../app/shared/StringUtil');
const ServerRequest = require('../../actions/request'); // TODO: create action -> store flow
const OrganizationActions = require('../../actions/OrganizationActions');
const OrganizationStore = require('../../stores/OrganizationStore');
//const AccountActions = require('../../actions/AccountActions');
const SubscriptionPlanStore = require('../../stores/SubscriptionPlanStore');
const SubscriptionPlanActions = require('../../actions/SubscriptionPlanActions');
const BadgeStore = require('../../stores/BadgeStore');
const BadgeActions = require('../../actions/BadgeActions');
const RSDStore = require('../../stores/RSDStore');
const RSDActions = require('../../actions/RSDActions');

import AccessibleIcon from '../common/AccessibleIcon';
const SubscriptionSettingsModal = require('../modal/SubscriptionSettingsModal');
import ErrorBox from '../common/ErrorBox';
import Tooltip from '../common/Tooltip';
import OrgAccountInfoEdit from './OrgAccountInfoEdit';
import OrgAddBadgeServiceModal from '../modal/OrgAddBadgeServiceModal';
import OrgEditBadgeServiceModal from '../modal/OrgEditBadgeServiceModal';
import OrgAddBadgeTemplateModal from '../modal/OrgAddBadgeTemplateModal';
import OrgViewBadgeTemplateDetails from '../modal/OrgViewBadgeTemplateDetails';
import ConfirmModal from '../modal/ConfirmModal';
import SortableTable2 from '../table/SortableTable2';
import OrgAddRSDServiceModal from '../modal/OrgAddRSDServiceModal';
import OrgEditRSDServiceModal from '../modal/OrgEditRSDServiceModal';
import OrgEditRSDsModal from '../modal/OrgEditRSDsModal';

import AssetImage from '../common/AssetImage';
import SingleAssetInput from '../common/SingleAssetInput';
const AssetUtil = require('../../util/asset');

const propTypes = {
    orgId: PropTypes.number.isRequired,
    backHandler: PropTypes.func.isRequired,
    heading: PropTypes.string,
    permissions: PropTypes.object.isRequired
};

const defaultProps = {
    heading: ''
};

class OrgAccountSettingsView extends React.Component {
    constructor(props) {
        super(props)

        const planStoreState = this.getStateFromPlanStoreState(SubscriptionPlanStore.getState());
        const organizationStoreState = OrganizationStore.getStateOrganization(props.orgId);
        const logoImageSrc = _.get(organizationStoreState,'orgUserSettings.custom_config.logoImageSrc','');
        
        this.state = {
            organizationStoreState,
            secretFieldType: 'password',
            optionsSaveEnabled: false,
            updateSettingsActionId: null,
            canSeeSecret: false,
            badgeStoreState: BadgeStore.getStateOrg(props.orgId),
            selectedBadgeServiceId: null,
            selectedBadgeTemplateHash: null,
            rsdStoreState: RSDStore.getStateOrg(props.orgId),
            selectedRSDServiceId: null,
            ...planStoreState
        }

        this.refreshUserInfo = this.refreshUserInfo.bind(this);
        this.toggleSecret = this.toggleSecret.bind(this);
        this.getStateFromPlanStoreState = this.getStateFromPlanStoreState.bind(this);
        this.openOrgSubscriptionSettingsModal = this.openOrgSubscriptionSettingsModal.bind(this);
        this.handleCloseOrgSubscriptionSettingsModal = this.handleCloseOrgSubscriptionSettingsModal.bind(this);
        this.renderOrgSubscriptionSettingsModal = this.renderOrgSubscriptionSettingsModal.bind(this);
        this.handleChangeOrgSubscriptionPromise = this.handleChangeOrgSubscriptionPromise.bind(this);
        this.handleCancelOrgSubscriptionPromise = this.handleCancelOrgSubscriptionPromise.bind(this);
        this.onEnableShareLinksChange = this.onEnableShareLinksChange.bind(this);
        this.onOptionsUpdate = this.onOptionsUpdate.bind(this);


        this.unsubscribes = [
            OrganizationStore.listen(this.onOrgStoreChange.bind(this)),
            SubscriptionPlanStore.listen(this.onSubscriptionPlanStoreChange.bind(this)),
            BadgeStore.listen(this.onBadgeStoreChange.bind(this)),
            RSDStore.listen(this.onRSDStoreChange.bind(this)),
        ];
    }

    componentDidMount() {
        OrganizationActions.getOrgInfoFull(uuid.v4(), { id: this.props.orgId });
        OrganizationActions.getOrgApiInfo(uuid.v4(), { id: this.props.orgId });
        OrganizationActions.getOrgUserSettings(uuid.v4(), { orgId: this.props.orgId });
        this.refreshUserInfo();
        this.refreshBadges();
        this.refreshRSDs();
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    refreshUserInfo() {
        SubscriptionPlanActions.getUpgradePlans(uuid.v4());
        SubscriptionPlanActions.getOwnedOrgSubscriptions(uuid.v4());
    }

    onOrgStoreChange(orgStoreState) {
        if (orgStoreState.action) {
            if (orgStoreState.action.id === this.state.uploadActionID) {
                let error = orgStoreState.action.error;
                if (error) {
                    this.setState({uploadActionID: null, error});
                }
                else {
                    let logoImageSrc = orgStoreState.action.url;
                    this.setState({uploadActionID: null, logoImageSrc},()=>{
                        this.onOptionsUpdate();
                    });
                }
                return;
            }
        }
        const organizationStoreState = OrganizationStore.getStateOrganization(this.props.orgId);
        const logoImageSrc = _.get(organizationStoreState,'orgUserSettings.custom_config.logoImageSrc','');
        
        this.setState({ organizationStoreState, logoImageSrc });
    }

    onSubscriptionPlanStoreChange(state) {
        const s = this.getStateFromPlanStoreState(state);
        return this.setState(s);
    }

    toggleSecret(e) {
        e.preventDefault();
        this.setState({ canSeeSecret: !this.state.canSeeSecret, secretFieldType: this.state.secretFieldType === 'password' ? 'text' : 'password' });
    }

    getStateFromPlanStoreState(state) {
        const user_plans = _.filter(state.upgrade_plans, plan => {
            return Globals.users.is_user_account_type(plan.account_type) && ( plan.process_type === Globals.ecommerce.process_types.CC);
        });

        const org_plans = _.filter(state.upgrade_plans, plan => {
            return Globals.users.is_org_account_type(plan.account_type) && ( plan.process_type === Globals.ecommerce.process_types.CC);
        });

        return {
            user_plans: user_plans,
            org_plans: org_plans,
            plan_prorate_data: state.plan_prorate_data,
            subscription_plan: state.subscription_plan,
            owned_org_subscriptions: state.owned_org_subscriptions,
        };
    }

    openOrgSubscriptionSettingsModal(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ showOrgSubscriptionSettingsModal: true });
    }

    handleCloseOrgSubscriptionSettingsModal() {
        this.setState({ showOrgSubscriptionSettingsModal: false }, () => {
            this.refreshUserInfo();
        });
    }

    renderOrgSubscriptionSettingsModal() {
        // const _userInfo = this.state.signInStoreState.userInfo;
        // var org = this.state.selectedOrg;
        const org = this.state.organizationStoreState.organizations[this.props.orgId];
        const selectedPlan = _.find(this.state.owned_org_subscriptions, { org_id: org.id });

        // console.log("org selectedPlan: " + JSON.stringify(selectedPlan));
        // org selectedPlan: {"org_id":124,"plan_id":"12","subscription_id":"16","subscription_status":"active","process_type":"CC","display_name":"Buyable Org","cost":1000,"interval":"month"}
        let existing_plan_id = '';
        let existing_subscription = null;
        if (selectedPlan) {
            existing_subscription = { // SubscriptionSettingsModal just needs the status currently.
                id: selectedPlan.subscription_id,
                status: selectedPlan.subscription_status,
            };
            existing_plan_id = selectedPlan.plan_id;
        }

        // console.log("this.state.plan_prorate_data: " + JSON.stringify(this.state.plan_prorate_data));
        const org_prorate_data = this.state.plan_prorate_data[org.id];
        // console.log("org_prorate_data: " + JSON.stringify(org_prorate_data));
        const available_plans = _.map(this.state.org_plans, function(plan) {
            const prorate_data = _.find(org_prorate_data, { id: plan.id });
            if (prorate_data) {
                // console.log("found prorate_data: " + JSON.stringify(prorate_data));
                return _.assign({
                    upgrade_cost: prorate_data.upgrade_cost,
                    proration_date: prorate_data.proration_date
                }, plan);
            }
            else {
                return plan;
            }
        });


        return (
            <SubscriptionSettingsModal
                title={'Organization Subscription Settings'}
                email={org.email}
                subscriber={org}
                available_plans={available_plans}
                existing_plan_id={existing_plan_id}
                existing_subscription={existing_subscription}
                changeSubscription={this.handleChangeOrgSubscriptionPromise}
                cancelSubscription={this.handleCancelOrgSubscriptionPromise}
                onClose={this.handleCloseOrgSubscriptionSettingsModal}
            />
        );

    } // renderOrgSubscriptionSettingsModal

    handleChangeOrgSubscriptionPromise(plan_id,token_id, proration_date) {
        // cost is the cost we told the user. It should match the upgrade cost
        return ServerRequest.makeRequest('/authoring/ecommerce/upgrade_account', 'POST', JSON.stringify({
            org_id: this.props.orgId,
            plan_id: plan_id,
            token_id: token_id,
            proration_date: proration_date, // Supply this so that what we tell the user matches what stripe calculates
        }));
    } // handleChangeOrgSubscriptionPromise

    handleCancelOrgSubscriptionPromise() {
        const selectedPlan = _.find(this.state.owned_org_subscriptions, { org_id: this.props.orgId });
        return ServerRequest.makeRequest('/authoring/ecommerce/cancel_subscription', 'POST', JSON.stringify({
            org_id: this.props.orgId,
            subscription_id: selectedPlan.subscription_id
        }));
    }

    onEnableShareLinksChange(e) {
        this.setState({ enableShareLinks: e.target.checked, optionsSaveEnabled: true });
    }
    
    onEnableStudentFeedbackChange=(e)=>{
        this.setState({ enableStudentFeedback: e.target.checked, optionsSaveEnabled: true });
    }
    
    uploadLogoImage=(params, files)=>{
        const uploadActionID = uuid.v4();
        this.setState({uploadActionID}, ()=>{
            OrganizationActions.addOrgAsset(
                uploadActionID,
                {
                    ...params,
                    org_id: this.props.orgId,
                },
                files
            );
        });
    }

    uploadError=(errorMessage)=>{
        this.setState({hasError: true, message: errorMessage});
        //alert("Asset upload failed! "+errorMessage);
    }
    

    onOptionsUpdate() {
        const actionId = uuid.v4();
        this.setState({ updateSettingsActionId: actionId }, () => {
            let changes = {
                orgId: this.props.orgId,
                enableShareLinks: this.state.enableShareLinks,
                enableStudentFeedback: this.state.enableStudentFeedback,
            }
            const custom_config = _.get(this.state.organizationStoreState,'orgUserSettings.custom_config',{});
            const original_logoImageSrc = custom_config.logoImageSrc || '';
            const logoImageSrc = this.state.logoImageSrc;
            if (logoImageSrc !== original_logoImageSrc) {
                changes.customConfig = { ...custom_config, logoImageSrc };
            }
            OrganizationActions.updateOrgUserSettings(actionId, changes);
        });
    }

    onBadgeStoreChange(state) {
        let badgeStoreState = BadgeStore.getStateOrg(this.props.orgId);
        this.setState({ badgeStoreState });
        if (state.action.id === this.state.detailActionId) {
            this.setState({detailActionId: null});
        }
    }

    refreshBadges=()=>{
        BadgeActions.getBadgeServices(uuid.v4(),this.props.orgId);
        BadgeActions.getBadgeTemplates(uuid.v4(),this.props.orgId);
    }
    
    onBadgeServiceButton=(key,id)=>{
        this.setState({selectedBadgeServiceId: id, modalState: key});
    }
    
    onAddBadgeService=(serviceData)=>{
        BadgeActions.addBadgeService(uuid.v4(),serviceData);
        this.onModalClose();
    }
    
    onChangeBadgeService=(serviceData)=>{
        this.setState({modalConfirm: {
            modalTitle: "Confirm Change",
            text: "Are you sure you wish to update this badge service?",
            confirmHandler: ()=>{
                this.setState({modalConfirm: null},()=>{
                    BadgeActions.updateBadgeService(uuid.v4(),serviceData);
                    this.onModalClose();
                })
            },
            cancelHandler: ()=>{
                this.setState({modalConfirm: null},()=>{
                    this.onModalClose();
                })
            },
        }});
    }
    
    onAddBadgeTemplate=(addTemplateData)=>{
        BadgeActions.addBadgeTemplate(uuid.v4(),this.props.orgId, addTemplateData);
        this.onModalClose();
    }

    onBadgeTemplateButton=(key,hash,e)=>{
        e.stopPropagation();
        this.setState({selectedBadgeTemplateHash: hash, modalState: key});
    }
    
    onRemoveBadgeTemplate=()=>{
        BadgeActions.removeBadgeTemplate(uuid.v4(),this.props.orgId,this.state.selectedBadgeTemplateHash);
        this.onModalClose();
    }


    onRSDStoreChange(state) {
        let rsdStoreState = RSDStore.getStateOrg(this.props.orgId);
        this.setState({ rsdStoreState });
    }

    refreshRSDs=()=>{
        RSDActions.getRSDServices(uuid.v4(),this.props.orgId);
    }
    
    onRSDServiceButton=(key,id)=>{
        this.setState({selectedRSDServiceId: id, modalState: key});
    }
    
    onAddRSDService=(serviceData)=>{
        RSDActions.addRSDService(uuid.v4(),serviceData);
        this.onModalClose();
    }
    
    onChangeRSDService=(serviceData)=>{
        //console.log("serviceData:",serviceData);
        this.setState({modalConfirm: {
            modalTitle: "Confirm Change",
            text: "Are you sure you wish to update this rsd service?",
            confirmHandler: ()=>{
                this.setState({modalConfirm: null},()=>{
                    RSDActions.updateRSDService(uuid.v4(),serviceData);
                    //this.onModalClose(); // keep open for testing?
                })
            },
            cancelHandler: ()=>{
                this.setState({modalConfirm: null},()=>{
                    //this.onModalClose(); // keep open for testing?
                })
            },
        }});
    }
    
    onModalClose=()=>{
        this.setState({modalState: null});
    }
    
    onBadgeTemplateClick=(hash)=>{
        const selectedBadgeTemplate = _.find(this.state.badgeStoreState.badgeTemplates,{badge_template_hash: hash});
        let detailActionId = null;
        if (!selectedBadgeTemplate.details) {
            detailActionId = uuid.v4();
            BadgeActions.getBadgeTemplateDetails(detailActionId,this.props.orgId,hash);
        }
        this.setState({
            modalState: 'show_badge_template_details', 
            selectedBadgeTemplateHash: hash,
            detailActionId,
        });
    }
    
    renderBadgeSection=()=>{
        const self = this;
        if (!this.state.badgeStoreState) {
            return null;
        }

        const badgeServiceRows = this.state.badgeStoreState.badgeServices.map((service)=>({
            id: service.id,
            org_user_id: service.org_user_id,
            name: service.name,
            service_type: service.service_type,
            // endpoints,
            // credentials
            edit_badge_service: service.id,
            add_badge_template: service.id,
        }));
        var selectedBadgeService = _.find(this.state.badgeStoreState.badgeServices,{id: this.state.selectedBadgeServiceId});
        
        const badgeTemplateRows = this.state.badgeStoreState.badgeTemplates.map((entry)=>({
            ...entry, 
            remove_badge_template: entry.badge_template_hash,
        }));
        var selectedBadgeTemplate = _.find(this.state.badgeStoreState.badgeTemplates,{badge_template_hash: this.state.selectedBadgeTemplateHash});
        var relatedService;
        if (selectedBadgeTemplate) {
            relatedService = _.find(this.state.badgeStoreState.badgeServices,{id: selectedBadgeTemplate.badge_service_id});
        }
        return (
            <div className="badge-section">
                <button
                    className="bare-text-button glyph fr"
                    title="Refresh All Badge Info"
                    onClick={this.refreshBadges}
                >
                    <span className="fa fa-refresh" aria-hidden="true"/>
                </button>
                
                <button className="admin-button fr" title="edit" onClick={(e)=>{this.setState({modalState: 'add_badge_service'})}}>
                    <AccessibleIcon className="fa fa-plus" label="add badge service">
                        Add Badge Service
                    </AccessibleIcon>
                </button>

                <SortableTable2
                    key="badge-service-table"
                    title="Badge Services"
                    uniqueRowKey="id"
                    onRowClick={this.onBadgeServiceClick}
                    rows={badgeServiceRows}
                    selectedRowKey={this.state.selectedBadgeServiceId}
                    columns={[
                        {
                            displayName: 'ID',
                            key:'id',
                            size: 1,
                            type: 'int'
                        },
                        {
                            displayName: 'Name',
                            key:'name',
                            size: 20,
                            type: 'string'
                        },
                        {
                            displayName: 'Service Type',
                            key:'service_type',
                            size: 5,
                            type: 'string'
                        },
                        {
                            displayName: 'Edit',
                            key: 'edit_badge_service',
                            size: 5,
                            type: 'custom'
                        },
                        {
                            displayName: 'Add Template',
                            key: 'add_badge_template',
                            size: 5,
                            type: 'custom'
                        },
                    ]}
                    displayColumnCallbacks={{
                        edit_badge_service: (dummy,id)=>(
                            <button className="table-button" title="edit" onClick={()=>{this.onBadgeServiceButton('edit_badge_service',id)}}>
                                <AccessibleIcon className="fa fa-pencil table-button" label="edit service">
                                    Edit
                                </AccessibleIcon>
                            </button>
                        ),
                        add_badge_template: (dummy,id)=>(
                            <button className="table-button" title="add template" onClick={()=>{this.onBadgeServiceButton('add_badge_template',id)}}>
                                <AccessibleIcon className="fa fa-plus table-button" label="add badge template">
                                    Add Template
                                </AccessibleIcon>
                            </button>
                        ),
                    }}
                />

                <SortableTable2
                    key="badge-template-table"
                    title="Badge Templates"
                    uniqueRowKey="badge_template_hash"
                    onRowClick={this.onBadgeTemplateClick}
                    rows={badgeTemplateRows}
                    selectedRowKey={this.state.selectedTemplateId}
                    columns={[
                        {
                            displayName: 'ID',
                            key:'badge_template_hash',
                            size: 1,
                            type: 'int'
                        },
                        {
                            displayName: 'Service',
                            key:'badge_service_name',
                            size: 1,
                            type: 'int'
                        },
                        {
                            displayName: 'Display Name',
                            key:'display_name',
                            size: 20,
                            type: 'string'
                        },
                        {
                            displayName: 'Remove',
                            key: 'remove_badge_template',
                            size: 5,
                            type: 'custom'
                        },
                    ]}
                    displayColumnCallbacks={{
                        remove_badge_template: (dummy,badge_template_hash)=>(
                            <button className="table-button" title="remove template" onClick={(e)=>{this.onBadgeTemplateButton('remove_badge_template',badge_template_hash,e)}}>
                                <AccessibleIcon className="fa fa-trash table-button" label="remove badge template">
                                    Remove Template
                                </AccessibleIcon>
                            </button>
                        ),
                    }}
                />

                {(this.state.modalState === 'add_badge_service') ?
                <OrgAddBadgeServiceModal org_user_id={this.props.orgId} badgeServices={this.state.badgeStoreState.badgeServices} submitHandler={this.onAddBadgeService} closeHandler={this.onModalClose}/>
                : null }

                {(this.state.modalState === 'edit_badge_service') ?
                <OrgEditBadgeServiceModal serviceData={selectedBadgeService} submitHandler={this.onChangeBadgeService} closeHandler={this.onModalClose}/>
                : null }

                {(this.state.modalState === 'add_badge_template') ?
                <OrgAddBadgeTemplateModal serviceData={selectedBadgeService} submitHandler={this.onAddBadgeTemplate} closeHandler={this.onModalClose}/>
                : null }

                {(this.state.modalState === 'remove_badge_template') ?
                    <ConfirmModal
                        show
                        modalTitle="Remove Badge Template"
                        text={`Are you sure you wish to remove ${selectedBadgeTemplate.display_name}?`}
                        buttonText="Remove"
                        closeHandler={this.onModalClose}
                        confirmHandler={this.onRemoveBadgeTemplate}
                    />
                : null }

                {(this.state.modalState === 'show_badge_template_details') ?
                <OrgViewBadgeTemplateDetails orgId={this.props.orgId} badgeService={relatedService} badgeTemplate={selectedBadgeTemplate} loading={!!this.state.detailActionId} closeHandler={this.onModalClose}/>
                : null }


            </div>
        );
    } // render badge section


    renderRSDSection=()=>{
        const self = this;
        if (!this.state.rsdStoreState) {
            return null;
        }
        const rsdServiceRows = this.state.rsdStoreState.rsdServices.map((service)=>({
            id: service.id,
            org_user_id: service.org_user_id,
            name: service.name,
            service_type: service.service_type,
            // details,
            edit_rsd_service: service.id,
        }));
        var selectedRSDService = _.find(this.state.rsdStoreState.rsdServices,{id: this.state.selectedRSDServiceId});
        
        let modalConfirm;
        if (this.state.modalConfirm) {
            let { modalTitle, text, confirmHandler, cancelHandler } = this.state.modalConfirm;
            modalConfirm = (
                <ConfirmModal key="modal"
                    theme="new"
                    show={true}
                    modalTitle={modalTitle}
                    text={text}
                    buttonText={"confirm"}
                    confirmHandler={confirmHandler}
                    cancelButtonText={"cancel"}
                    cancelHandler={cancelHandler}
                    closeHandler={cancelHandler}
                    confirmButtonBsStyle="info"
                    cancelButtonBsStyle="info"
                    enforceFocus
                    restoreFocus
                    backdrop
                />
            );
        }
        
        return (
            <div className="rsd-section">
                <button
                    className="bare-text-button glyph fr"
                    title="Refresh All RSD Info"
                    onClick={this.refreshRSDs}
                >
                    <span className="fa fa-refresh" aria-hidden="true"/>
                </button>
                
                <button className="admin-button fr" title="edit" onClick={(e)=>{this.setState({modalState: 'add_rsd_service'})}}>
                    <AccessibleIcon className="fa fa-plus" label={Strings['en'].RSD.ADD_RSD_SERVICE}>
                        {Strings['en'].RSD.ADD_RSD_SERVICE}
                    </AccessibleIcon>
                </button>

                <SortableTable2
                    key="rsd-service-table"
                    title={Strings['en'].RSD.RSD_SERVICES_LABEL}
                    uniqueRowKey="id"
                    onRowClick={this.onRSDServiceClick}
                    rows={rsdServiceRows}
                    selectedRowKey={this.state.selectedRSDServiceId}
                    columns={[
                        {
                            displayName: 'ID',
                            key:'id',
                            size: 1,
                            type: 'int'
                        },
                        {
                            displayName: 'Name',
                            key:'name',
                            size: 20,
                            type: 'string'
                        },
                        {
                            displayName: 'Service Type',
                            key:'service_type',
                            size: 5,
                            type: 'string'
                        },
                        {
                            displayName: 'Edit Service',
                            key: 'edit_rsd_service',
                            size: 5,
                            type: 'custom'
                        },
                        {
                            displayName: 'Edit Skills',
                            key: 'edit_rsds',
                            size: 5,
                            type: 'custom'
                        },
                    ]}
                    displayColumnCallbacks={{
                        edit_rsd_service: (dummy,id)=>{
                            return (
                                <button className="table-button" title="edit" onClick={()=>{this.onRSDServiceButton('edit_rsd_service',id)}}>
                                    <AccessibleIcon className="fa fa-pencil table-button" label="view or edit service">
                                        Edit Service
                                    </AccessibleIcon>
                                </button>
                            );
                        },

                        edit_rsds: (dummy,id)=>{
                            let service = _.find(this.state.rsdStoreState.rsdServices,{id});
                            if (service && (service.service_type === Globals.RSD_SERVICE_TYPES.MZL)) {
                                return (
                                    <button className="table-button" title="edit" onClick={()=>{this.onRSDServiceButton('edit_rsds',id)}}>
                                        <AccessibleIcon className="fa fa-pencil table-button" label="view/edit skill descriptors">
                                            Edit Skills
                                        </AccessibleIcon>
                                    </button>
                                );
                            }
                            
                            return <span>{'N/A'}</span>
                        },


                        add_badge_template: (dummy,id)=>(
                            <button className="table-button" title="add template" onClick={()=>{this.onRSDServiceButton('add_badge_template',id)}}>
                                <AccessibleIcon className="fa fa-plus table-button" label="add rsd template">
                                    Add Template
                                </AccessibleIcon>
                            </button>
                        ),
                    }}
                />

                {(this.state.modalState === 'add_rsd_service') ?
                <OrgAddRSDServiceModal org_user_id={this.props.orgId} rsdServices={this.state.rsdStoreState.rsdServices} submitHandler={this.onAddRSDService} closeHandler={this.onModalClose}/>
                : null }

                {(this.state.modalState === 'edit_rsd_service') ?
                <OrgEditRSDServiceModal serviceData={selectedRSDService} submitHandler={this.onChangeRSDService} closeHandler={this.onModalClose}/>
                : null }
                
                {(this.state.modalState === 'edit_rsds') ?
                <OrgEditRSDsModal orgId={this.props.orgId} serviceData={selectedRSDService} closeHandler={this.onModalClose}/>
                : null }
                
                { modalConfirm }

            </div>
        );
    } // render RSD section

    

    render() {
        const _organization = this.state.organizationStoreState.organization;
        const _orgApiInfo = this.state.organizationStoreState.orgApiInfo;
        const _orgUserSettings = this.state.organizationStoreState.orgUserSettings;
        if (!_organization || !_orgApiInfo || !_orgUserSettings) {
            return null;
        }

        const orgSubscription = find(this.state.owned_org_subscriptions, { org_id: this.props.orgId });
        const isPOSub = !!orgSubscription && orgSubscription.process_type === Globals.ecommerce.process_types.PO;

        return (
            <div>
                {this.state.showOrgSubscriptionSettingsModal && this.renderOrgSubscriptionSettingsModal()}
                <div className="channelHeadingFlex">
                    <div className="channelHeadingFlex__heading">
                        <button
                        className="btn btn-primary glyph btn-circle btn-lg margin-right-15"
                        onClick={this.props.backHandler}
                        title="Back">
                            <AccessibleIcon label="Back">
                                <span className="fa fa-chevron-left" aria-hidden="true"/>
                            </AccessibleIcon>
                        </button>
                        <h2 className="heading-lg">{this.props.heading ? this.props.heading + " - Account Settings" : "Account Settings"}</h2>
                    </div>
                </div>
                <div className="tile-dash-floating user-profile">
                    <Form>
                        <OrgAccountInfoEdit className="margin-bottom-xl" orgId={_organization.id} />

                        <div className="margin-bottom-xl">
                            <h2>Account Plan</h2>
                            <hr/>
                            <div className="margin-bottom-15">
                                <label className="label-form" htmlFor="user-account-type">
                                    plan type
                                </label>
                                <div id="user-account-type">
                                    {StringUtil.getStingForAccountType(_organization.account_type)}
                                </div>
                            </div>
                            <div className="margin-bottom-15">
                                <label className="label-form" htmlFor="user-sub-type">
                                    subscription type
                                </label>
                                <div id="user-sub-type">
                                    { !!orgSubscription ?
                                        orgSubscription.display_name
                                        :
                                        'Unsubscribed'
                                    }
                                </div>
                            </div>
                            <div className="margin-bottom-15">
                                <div className="margin-bottom-15">
                                    <label className="label-form" htmlFor="user-sub-status">subscription status</label>
                                    <div id="user-sub-status">
                                        { !!orgSubscription ?
                                            StringUtil.getStringForSubscriptionStatus(orgSubscription.subscription_status)
                                            :
                                            'Unsubscribed'
                                        }
                                    </div>
                                </div>
                                {(!!orgSubscription && !isPOSub) &&
                                    <Button onClick={this.openOrgSubscriptionSettingsModal}>
                                        <span className="fa fa-shopping-basket" aria-hidden="true" />subscription
                                    </Button>
                                }
                                <ErrorBox error={this.state.buy_org_error} />
                            </div>
                        </div>

                        <div className="margin-bottom-xl">
                            <h2>Organization Options</h2>
                            <hr />
                            <Form.Group className="margin-bottom-15">
                                <div>
                                    <div>
                                        <AssetImage
                                            src={this.state.logoImageSrc}
                                            alt={Strings['en'].organization.logo.ALT}
                                            className="parent-constrained"
                                            aria-hidden={true}
                                        />
                                    </div>
                                    <div>
                                        <SingleAssetInput
                                            buttonOnly
                                            browseText={Strings['en'].organization.logo.BTN_TEXT}
                                            assetType="image"
                                            assetRole="normal"
                                            accept="image/*"
                                            onChange={this.uploadLogoImage}
                                            onError={this.uploadError}
                                            validateAssetType={AssetUtil.validateImageMimeType}
                                            disabled={!!this.state.uploadActionID}
                                        />
                                    </div>
                                    <ErrorBox error={this.state.error} />
                                    <div className="vertical-spacer"/>
                                </div>
                            
                                <Form.Check
                                    checked={typeof this.state.enableShareLinks === 'boolean' ? this.state.enableShareLinks : _orgUserSettings.enable_share_links}
                                    onChange={this.onEnableShareLinksChange}
                                    inline
                                    label="Enable Share Links"
                                />
                                <Tooltip id="st-share-links" placement="right" className="margin-left-sm">
                                    Include <em className="font-style-italic">Share Link</em> in Activity view. Disabling this will hide the link.
                                </Tooltip>
                            </Form.Group>
                            <Form.Group className="margin-bottom-15">
                                <Form.Check
                                    checked={typeof this.state.enableStudentFeedback === 'boolean' ? this.state.enableStudentFeedback : _orgUserSettings.enable_student_feedback}
                                    onChange={this.onEnableStudentFeedbackChange}
                                    inline
                                    label="Enable Student Feedback"
                                />
                                <Tooltip id="st-student-feedback" placement="right" className="margin-left-sm">
                                    enable <em className="font-style-italic">Student Feedback</em> during Activity student attempts. Disabling this will hide the feedback button.
                                </Tooltip>
                                
                            </Form.Group>
                            <Button
                                disabled={!this.state.optionsSaveEnabled || !!this.state.updateSettingsActionId}
                                onClick={this.onOptionsUpdate}
                            >
                                save changes
                            </Button>
                        </div>

                        <div className="margin-bottom-xl">
                            <h2>Integration Information</h2>
                            <hr/>
                            <Form.Group controlId="settings-partner-key">
                                <Form.Label>partner key</Form.Label>
                                <Form.Control
                                    type="text"
                                    aria-label="Partner Key"
                                    defaultValue={_orgApiInfo.key}
                                    disabled
                                />
                            </Form.Group>
                            <Form.Group controlId="settings-partner-secret">
                                <Form.Label>partner secret</Form.Label>
                                <Form.Control
                                    type={this.state.secretFieldType}
                                    aria-label="Partner Secret"
                                    defaultValue={_orgApiInfo.secret}
                                    disabled
                                />
                            </Form.Group>

                            <Button onClick={this.toggleSecret}>
                                <AccessibleIcon label="Toggle show secret">
                                    <span className={!this.state.canSeeSecret ? "fa fa-eye" : "fa fa-eye-slash"} aria-hidden="true" />
                                </AccessibleIcon>
                            </Button>
                        </div>
                    </Form>
                </div>
                <hr/>
                {this.renderBadgeSection()}
                <hr/>
                {this.renderRSDSection()}
            </div>
        )
    }
}

OrgAccountSettingsView.propTypes = propTypes;
OrgAccountSettingsView.defaultProps = defaultProps;

export default OrgAccountSettingsView;